import script from "./FileLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileLink.vue?vue&type=script&setup=true&lang=ts"

import "./FileLink.vue?vue&type=style&index=0&id=701899f6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701899f6"]])

export default __exports__